import { IListItem } from '@nkr/models/index';
import { DonorPreselectReviewStatus } from '@nkr/enums/index';
import { Label } from 'react-bootstrap';
import OverlayMenuButton, { IMenuItem } from '@nkr/components/overlay-menu-button';

interface IProps {
    recipientId: number,
    donorId: number,
    reviewStatus: DonorPreselectReviewStatus,
    reviewStatusList: IListItem[],
    onToggle: (show: boolean) => void,
    onChange: (recipientId: number, donorId: number, reviewType: DonorPreselectReviewStatus) => void
}

const ReviewStatus = (props: IProps) => {
    const handleAction = (status: number) => {
        props.onChange(props.recipientId, props.donorId, status);
    };

    let currentType = props.reviewStatusList.find(x => x.id == props.reviewStatus)

    let style = 'default';
    let text = '--';
    let title = currentType != null ? currentType.description : '';

    if (props.reviewStatus == DonorPreselectReviewStatus.NeedsMedicalReview) {
        style = 'warning';
        text = 'M';
        ;
    }

    if (props.reviewStatus == DonorPreselectReviewStatus.NeedsSurgicalReview) {
        style = 'info';
        text = 'S';
    }

    if (props.reviewStatus == DonorPreselectReviewStatus.NeedsHlaReview) {
        style = 'danger';
        text = 'H';
    }

    if (props.reviewStatus == DonorPreselectReviewStatus.NeedsCoordinatorReview) {
        style = 'success';
        text = 'T';
    }

    let menu: IMenuItem[] = props.reviewStatusList.map(x => {
        let labelStyle = '';

        if (x.abbreviation == 'M') {
            labelStyle = 'warning';
        }

        if (x.abbreviation == 'S') {
            labelStyle = 'info';
        }

        if (x.abbreviation == 'H') {
            labelStyle = 'danger';
        }

        if (x.abbreviation == 'T') {
            labelStyle = 'success';
        }

        return {
            id: 0, action: x.id, include: true, selectable: true, element: <><Label bsStyle={labelStyle}>{x.abbreviation}</Label> - {x.description}</>
        };
    });

    menu.splice(0, 0, { id: 0, action: null, include: true, selectable: true, element: <>- No Review-</> });

    return (
        <OverlayMenuButton
            menu={menu}
            bsStyle={style}
            bsSize='xs'
            title={text}
            buttonTitle={title}
            onToggle={props.onToggle}
            onSelect={(id, action) => handleAction(action)} />
    )
}

export default ReviewStatus;